export default "__VITE_ASSET__NV23k4z$__"